export default __webpack_public_path__ + "static/media/5_1_0.165c9c20.png";